export default __webpack_public_path__ + "static/media/ee01ccdb60519aec.59745e6d77938697731ab5fb72725904.svg";